import { Link } from "react-router-dom";
import { siteVision } from "@/mocks/site";

const heroStats = [
  { value: "42,860", label: "累计受理举报" },
  { value: "3,174", label: "争议事件建档" },
  { value: "17 小时", label: "平均受理时长" },
  { value: "96.4%", label: "结果公示率" },
];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20live%20streaming%20broadcast%20grids%20and%20signal%20waveforms%20over%20a%20deep%20warm%20dark%20background%2C%20vermilion%20and%20amber%20accents%2C%20editorial%20grain%20texture%2C%20cinematic%20atmosphere%2C%20no%20text&width=1800&height=1100&seq=home-hero-01&orientation=landscape"
          alt="爆料直播 直播争议举报与处理公示平台视觉图"
          title="爆料直播 - 直播举报通道与处理结果公示"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-32 pb-14 md:pb-20">
        <div className="max-w-4xl">
          <span className="rise-in inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-100/25 text-xs font-medium tracking-wide text-background-100">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400" aria-hidden="true"></span>
            爆料直播 · 直播争议举报与处理公示平台
          </span>

          <h1 className="rise-in rise-in-1 mt-6 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.15] text-background-50 text-balance">
            直播争议不再石沉大海，爆料直播给你一条查得到结果的通道
          </h1>

          <p className="rise-in rise-in-2 mt-6 text-sm md:text-lg leading-relaxed text-background-200 max-w-2xl">
            遇到画面中断、主播违规、打赏与抽奖争议，直接提交线索。平台 24 小时内受理，全程跟踪争议事件进展，处理结果第一时间同步并公开公示。
          </p>

          <div className="rise-in rise-in-3 mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/report"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-live-line" aria-hidden="true"></i>
              立即提交举报
            </Link>
            <Link
              to="/events"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-base font-medium border border-background-100/30 text-background-50 hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              查看争议事件
            </Link>
          </div>

          <p className="rise-in rise-in-4 mt-6 text-xs md:text-sm text-background-300">{siteVision}</p>
        </div>

        <dl className="rise-in rise-in-4 mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-background-100/15 rounded-lg overflow-hidden border border-background-100/15">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-black/25 backdrop-blur-sm px-4 md:px-6 py-5">
              <dt className="text-xs text-background-300">{stat.label}</dt>
              <dd className="mt-2 font-heading text-xl md:text-2xl font-bold text-background-50">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}